import React from 'react';
import history from "../utils/history";
import Button from "../components/Button";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {useTranslation} from "react-i18next";

const AppFormCancelButton = props => {
  const { t } = useTranslation('app_form')
  const [modalOpen, setModalOpen] = React.useState(false);
  const toggleModalOpen = () => setModalOpen(!modalOpen);

  return <React.Fragment>
    <div className="btn btn-light cursor-pointer" onClick={e => {
      e.preventDefault()
      toggleModalOpen()
    }}>{t('cancel_button.btn')}</div>

    {modalOpen && <Modal isOpen toggle={toggleModalOpen}>
      <ModalHeader toggle={toggleModalOpen}>{t('cancel_button.modal_header')}</ModalHeader>
      <hr className="my-0"/>
      <ModalBody>
        <span>{t('cancel_button.modal_body')}</span>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" className="mb-0" onClick={toggleModalOpen}>{t('common:btn.cancel')}</Button>
        <Button
          color="primary"
          onClick={history.goBack}
        >{t('cancel_button.modal_footer_btn_confirm')}</Button>
      </ModalFooter>
    </Modal>}
  </React.Fragment>;
};

AppFormCancelButton.propTypes = {

};

export default AppFormCancelButton;
